/* eslint-disable @typescript-eslint/no-unnecessary-condition */
// traps Tab navigation inside a container, preventing focus from escaping
export function trapFocus(
  navigationRef?: HTMLDivElement | HTMLUListElement | null,
  triggerElement?: HTMLElement | null,
): () => void {
  if (!navigationRef || !triggerElement) return () => {};

  const focusableEls = getKeyboardFocusableElements(navigationRef);

  // Focus first element on next paint frame
  requestAnimationFrame(() => {
    focusableEls[0]?.focus();
  });

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key !== 'Tab') return;

    const currentFocusableEls = getKeyboardFocusableElements(navigationRef);
    const activeEl = document.activeElement as HTMLElement;

    if (!currentFocusableEls.length) {
      e.preventDefault();
      triggerElement.focus();
      return;
    }

    const firstEl = currentFocusableEls[0];
    const lastEl = currentFocusableEls[currentFocusableEls.length - 1];

    if (!navigationRef.contains(activeEl)) {
      e.preventDefault();
      triggerElement.focus();
      return;
    }

    if (e.shiftKey) {
      if (activeEl === firstEl) {
        e.preventDefault();
        lastEl.focus();
      }
    } else if (activeEl === lastEl) {
      e.preventDefault();
      firstEl.focus();
    }
  };
  navigationRef.addEventListener('keydown', handleKeyDown as EventListener);
  return () => {
    navigationRef.removeEventListener('keydown', handleKeyDown as EventListener);
  };
}

export function getKeyboardFocusableElements(container: HTMLElement): HTMLElement[] {
  const focusableSelectors = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])',
  ];

  return Array.from(container.querySelectorAll<HTMLElement>(focusableSelectors.join(','))).filter(
    (el) => {
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    },
  );
}

export const trapFocusWithDelay = (
  element: HTMLDivElement | HTMLUListElement,
  triggerButton: HTMLElement,
  delay: number,
) => {
  setTimeout(() => {
    if (element && triggerButton) {
      trapFocus(element, triggerButton);
    }
  }, delay);
};

export const handleSubmenuFocus = (
  submenuRef: React.RefObject<HTMLDivElement | HTMLUListElement>,
  triggerButtonRef: HTMLButtonElement,
  focusDelay: number,
) => {
  if (submenuRef.current && triggerButtonRef) {
    trapFocusWithDelay(submenuRef.current, triggerButtonRef, focusDelay);
  }
};
